import { useEffect } from "react";

const useClickAway = (ref, localState, callback) => {
    useEffect(()=>{
        const handleClickOutside = (event) => {
            if (!localState) return;
            if(ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside)
        }
    },[ref, callback])
}
export default useClickAway;